import axios from 'axios'
import { BASE_URL } from 'config/env'
import { createTruckbookApiErrorInterceptor } from 'repositories/createTruckbookApiErrorInterceptor'
import {
  camelizeResponseInterceptor,
  decamelizeRequestInterceptor,
  setAuthHeaders,
} from 'repositories/utils/interceptors'

export const shipmentApiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
})

shipmentApiClient.interceptors.request.use((config) => {
  setAuthHeaders(config)
  return decamelizeRequestInterceptor(config)
})
shipmentApiClient.interceptors.response.use(
  camelizeResponseInterceptor,
  createTruckbookApiErrorInterceptor()
)
